module.exports = __webpack_public_path__ + "static/BookDinners-629e6864f8cf93cff888d136de14568d.svg";